import { useState, useEffect, Fragment } from "react";
import Board from "components/Meta/Board";
import StdButton from "components/Buttons/StdButton";
import { ArrowLeftCircleIcon } from "components/Icons";
import ModelEvents from "../models/ModelEvents";
import mainStore from "store/mainStore";
import proxy from "api/proxy";

export const ModalWizzardEvents = ({ onClose }) => {
  const ctxEvents = ModelEvents.ctxView();
  const {
    updateStore,
    updateRecord,
    reload,
    record: activeRecord,
    store,
  } = mainStore.getState();
  const [selectFolio, setSelectedFolio] = useState(null);
  const getEvents = async () => {
    // Revisión data unused
    const { data: dataEvents } = await proxy.search(
      "sale.sale",
      ["state", "=", "draft"],
      [
        "rec_name",
        "number",
        "description",
        "state",
        "party",
        "party.name",
        "sale_date",
      ],
    );
    dataEvents;
  };

  const addEvents = async (record) => {
    const _activeRecord = { ...activeRecord };
    const _storeRecord = { ...store };
    _activeRecord.party = record["main_guest."];
    _activeRecord.id_event = record.id;
    _storeRecord.party = record["main_guest."];
    setSelectedFolio(record);
  };

  ctxEvents.webfields.add.method = addEvents;

  const handlerTransferEvent = async () => {
    if (!selectFolio || !selectFolio.id) return;
    const _storeRecord = { ...store };
    _storeRecord.status = "transferred";
    _storeRecord.state = "transferred";
    const { data: resTransfer, error } = await proxy.methodCall({
      model: "sale.sale",
      method: "transfer_to_sale",
      args: [_storeRecord.id, selectFolio.id],
    });
    if (resTransfer) {
      reload();
      onClose();
    }
  };

  const cancelledFolio = () => {
    const _activeRecord = { ...activeRecord };
    const _storeRecord = { ...store };
    _activeRecord.party = null;
    _storeRecord.party = null;
    updateRecord(_activeRecord);
    updateStore(_storeRecord);
    onClose();
  };

  useEffect(() => {
    getEvents();
  }, []);

  return (
    <Fragment>
      {selectFolio ? (
        <div className="px-10">
          <ArrowLeftCircleIcon
            className="w-10 absolute right-10 top-2 cursor-pointer flex text-2xl my-auto fi button_back text-lime-700 bg-lime-200 h-10  rounded-xl py-1 px-2 items-center text-center hover:opacity-90 disabled:opacity-50 justify-center gap-2 active:scale-95"
            onClick={() => setSelectedFolio(null)}
          />
          <div className="mt-10">
            <div className="font-medium text-xl mb-3">Datos de evento</div>
            <div>id: {selectFolio.id}</div>
            <div>Numero del evento: {selectFolio.number}</div>
            <div>
              Nombre evento:{" "}
              {selectFolio["party."].name || selectFolio.description}
            </div>
          </div>
          <div className="flex mx-auto space-x-3 justify-center mt-10">
            <StdButton
              content="Transferir a evento"
              color="bluePresik"
              style="uppercase w-[200px]"
              onClick={() => handlerTransferEvent()}
            />
            <StdButton
              content="Cancelar"
              color="rose"
              style="uppercase w-[200px] "
              onClick={() => cancelledFolio()}
            />
          </div>
        </div>
      ) : (
        <div className="headerEvents pr-8">
          {" "}
          <Board ctxView={ctxEvents} />{" "}
        </div>
      )}
    </Fragment>
  );
};
